// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { compose } from 'redux';
import getGiftReceiptReturnDays from '@tcp/core/src/components/features/CnC/common/organism/GiftReceipt/container/GiftReceipt.selectors';
import { isClient } from '@tcp/core/src/utils';
import {
  getIsCrossBrandMerchandisingEnabled,
  getBOSSOrderStatusEnabled,
  getIsBIAOrderDetailsEnabled,
  getIsHardcodeSizeMapEnabled,
  getHardcodeSizeMapConfig,
  getAddPickUpPersonEnabled,
  getAltPersonLimit,
  getAltPersonInvalidOrderStatus,
  getOrderDetailsRecommendations,
  getIsCashAppAfterpayLogoEnabled,
  getIsCSHEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import OrderDetailsDataReducer from '@tcp/core/src/components/features/account/OrderDetails/container/OrderDetails.reducer';
import OrderDetailsListSaga from '@tcp/core/src/components/features/account/OrderDetails/container/OrderDetails.saga';
import { updateAppTypeWithParams } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import OrderDetailsView from '../views';
import { getOrderDetails } from './OrderDetails.actions';
import {
  getOrderDetailsDataState,
  getOrderReceiptReturnDays,
  getOrderDetailsDataFetchingState,
  getOrderLookUpAPISwitch,
  getIsAppeasementEnabled,
  getOrderDetailsError,
} from './OrderDetails.selectors';
import { getUserLoggedInState, mprUserId } from '../../User/container/User.selectors';
import ORDERDETAILS_CONSTANTS from '../OrderDetails.constants';
import { getErrorMessage } from '../../TrackOrder/container/TrackOrder.selectors';
import { openQuickViewWithValues } from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { getIsQVOpen } from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import {
  openForm,
  showSuccessMessage,
} from '../organism/AddPickupPerson/container/AddPickUpPersonForm.actions';
import {
  getFormState,
  isShowSuccessMessage,
} from '../organism/AddPickupPerson/container/AddPickUpPersonForm.selectors';

export const getOrderDetailsParams = (props) => {
  let orderId = '';
  let emailAddress = '';
  let fromEpsilon = '';
  let isFromTrackOrder = '';
  let isPastOrder = false;
  if (isClient()) {
    const {
      PATH: { TRACK_ORDER, ORDER_DETAILS },
    } = ORDERDETAILS_CONSTANTS;
    const url = window.location.pathname;
    const trackOrderString = url.split(url.match(TRACK_ORDER) ? TRACK_ORDER : ORDER_DETAILS);
    const trackOrderStringArray = Array.isArray(trackOrderString) && trackOrderString[1];
    const orderInformation = (trackOrderStringArray && trackOrderStringArray.split('/')) || [];
    [orderId = '', emailAddress = '', fromEpsilon = ''] = orderInformation;
    isFromTrackOrder = url.split('/').includes('track-order');
    isPastOrder = window?.location?.href?.includes('pastOrder');
  } else {
    const {
      orderId: propsOrderID = '',
      emailAddress: propsEmailAddress = '',
      fromEpsilon: propsFromEpsilon = '',
    } = props;
    isPastOrder = props?.route?.params?.isPastOrder;
    orderId = propsOrderID;
    emailAddress = propsEmailAddress;
    fromEpsilon = propsFromEpsilon;
    if (orderId === '' && props?.router?.query?.orderId) {
      orderId = props?.router?.query?.orderId;
    }
  }

  return {
    orderId,
    emailAddress,
    fromEpsilon,
    isFromTrackOrder,
    isPastOrder,
  };
};

/**
 * This Class component use for return the Order Details data
 * can be passed in the component.
 * @param state - initial state of selectedActivity set to be null
 */
export class OrderDetailsContainer extends PureComponent {
  componentDidMount() {
    this.setOrderUpdate();
  }

  componentWillUnmount() {
    const { setShowSuccessMsgAction } = this.props;
    setShowSuccessMsgAction(false);
  }

  componentDidUpdate(prevProps) {
    const { getOrderDetailsAction, orderDetailsData, orderLookUpAPISwitch } = this.props;
    const { orderId, emailAddress, fromEpsilon, isFromTrackOrder, isPastOrder } =
      getOrderDetailsParams(this.props);

    const payload = {
      orderId,
      emailAddress,
      fromEpsilon,
      orderLookUpAPISwitch,
      isPastOrder,
    };
    if (
      orderId &&
      prevProps.orderId !== orderId &&
      orderDetailsData &&
      orderDetailsData.orderNumber !== orderId &&
      !isFromTrackOrder
    ) {
      getOrderDetailsAction(payload);
    }
  }

  setOrderUpdate = () => {
    const { getOrderDetailsAction, orderDetailsData, orderLookUpAPISwitch } = this.props;

    const { orderId, emailAddress, fromEpsilon, isPastOrder } = getOrderDetailsParams(this.props);

    const payload = {
      orderId,
      emailAddress,
      fromEpsilon,
      orderLookUpAPISwitch,
      isPastOrder,
    };
    if (
      orderId &&
      (!orderDetailsData || (orderDetailsData && orderDetailsData.orderNumber !== orderId))
    ) {
      getOrderDetailsAction(payload);
    }
  };

  /**
   * @function render  Used to render the JSX of the component
   * @param    {[Void]} function does not accept anything.
   * @return   {[Object]} JSX of the component
   */

  render() {
    const {
      orderDetailsData,
      navigation,
      isFetching,
      isLoggedIn,
      userAccountId,
      returnDays,
      isErrorInOrderDetailFetching,
      isCrossBrandMerchandisingEnabled,
      isBOSSOrderStatusEnabled,
      updateAppTypeHandler,
      isQVModalOpen,
      isHardcodeSizeMapEnabled,
      hardcodeSizeMapConfig,
      isShowSuccessMessageState,
      setShowSuccessMsgAction,
      formState,
      orderDetailsRecommendationsEnabled,
      isOrderDetailsError,
    } = this.props;
    const { orderId, isPastOrder } = getOrderDetailsParams(this.props);
    return (
      <OrderDetailsView
        {...this.props}
        orderDetailsData={orderDetailsData}
        orderId={orderId}
        navigation={navigation}
        isFetching={isFetching}
        isLoggedIn={isLoggedIn}
        returnDays={returnDays}
        userAccountId={userAccountId}
        isErrorInOrderDetailFetching={isErrorInOrderDetailFetching}
        isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
        isBOSSOrderStatusEnabled={isBOSSOrderStatusEnabled}
        updateAppTypeHandler={updateAppTypeHandler}
        isQVModalOpen={isQVModalOpen}
        isHardcodeSizeMapEnabled={isHardcodeSizeMapEnabled}
        hardcodeSizeMapConfig={hardcodeSizeMapConfig}
        isPastOrder={isPastOrder}
        setShowSuccessMsgAction={setShowSuccessMsgAction}
        isShowSuccessMessageState={isShowSuccessMessageState}
        formState={formState}
        orderDetailsRecommendationsEnabled={orderDetailsRecommendationsEnabled}
        isOrderDetailsError={isOrderDetailsError}
      />
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    getOrderDetailsAction: (payload) => {
      dispatch(getOrderDetails(payload));
    },
    updateAppTypeHandler: (payload) => {
      dispatch(updateAppTypeWithParams(payload));
    },
    onQuickViewOpenClick: (payload) => dispatch(openQuickViewWithValues(payload)),
    setShowSuccessMsgAction: (payload) => {
      dispatch(showSuccessMessage(payload));
    },
    openFormAction: (payload) => {
      dispatch(openForm(payload));
    },
  };
};

export const mapStateToProps = (state, ownProps) => {
  return {
    orderId: ownProps?.router?.query?.orderId,
    emailAddress: ownProps?.router?.query?.emailAddress,
    fromEpsilon: ownProps?.router?.query?.fromEpsilon,
    orderDetailsData: getOrderDetailsDataState(state),
    orderReturnDays: getOrderReceiptReturnDays(state),
    isFetching: getOrderDetailsDataFetchingState(state),
    isLoggedIn: getUserLoggedInState(state),
    userAccountId: mprUserId(state),
    returnDays: getGiftReceiptReturnDays(state),
    orderLookUpAPISwitch: getOrderLookUpAPISwitch(state),
    isAppeasementEnabled: getIsAppeasementEnabled(state),
    isCrossBrandMerchandisingEnabled: getIsCrossBrandMerchandisingEnabled(state),
    isErrorInOrderDetailFetching: getErrorMessage(state),
    isBOSSOrderStatusEnabled: getBOSSOrderStatusEnabled(state),
    isBIAOrderDetailsEnabled: getIsBIAOrderDetailsEnabled(state),
    isQVModalOpen: getIsQVOpen(state),
    isHardcodeSizeMapEnabled: getIsHardcodeSizeMapEnabled(state),
    hardcodeSizeMapConfig: getHardcodeSizeMapConfig(state),
    isAddAltPickupPersonEnabled: getAddPickUpPersonEnabled(state),
    altPickupPersonLimit: getAltPersonLimit(state),
    altPickupPersonInvaildOrderStatus: getAltPersonInvalidOrderStatus(state),
    isShowSuccessMessageState: isShowSuccessMessage(state),
    formState: getFormState(state),
    orderDetailsRecommendationsEnabled: getOrderDetailsRecommendations(state),
    isOrderDetailsError: getOrderDetailsError(state),
    isCashAppAfterpayLogoEnabled: getIsCashAppAfterpayLogoEnabled(state),
    isCSHEnabled: getIsCSHEnabled(state),
  };
};

OrderDetailsContainer.propTypes = {
  emailAddress: PropTypes.string,
  orderId: PropTypes.string,
  orderDetailsData: PropTypes.shape({}),
  getOrderDetailsAction: PropTypes.func.isRequired,
  navigation: PropTypes.shape({}),
  isFetching: PropTypes.bool,
  userAccountId: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  orderLookUpAPISwitch: PropTypes.bool,
  returnDays: PropTypes.number,
  fromEpsilon: PropTypes.string,
};

OrderDetailsContainer.defaultProps = {
  emailAddress: '',
  orderId: '',
  orderDetailsData: {},
  navigation: {},
  isFetching: false,
  isLoggedIn: false,
  orderLookUpAPISwitch: false,
  userAccountId: '',
  returnDays: 45,
  fromEpsilon: '',
};

const withReducer = withDynamicReducer({
  key: 'OrderDetailsReducer',
  reducer: OrderDetailsDataReducer,
});
const withSaga = withDynamicSaga({ key: 'OrderDetailsSaga', saga: OrderDetailsListSaga });
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withReducer, withSaga, withConnect)(OrderDetailsContainer);
